/**
 * 에셋이 아직 CDN 에 없거나 404 일 때의 자리표시.
 *
 * 브라우저 기본 깨진-이미지 아이콘 대신 **어떤 파일이 없는지** 를 보여준다.
 * 문서를 쓰는 동안(에셋 업로드 전) 계속 보게 되는 화면이라 여기서 키를 읽을 수
 * 있어야 한다.
 */
export function DocsAssetFallback({
  assetKey,
  alt,
}: {
  assetKey: string;
  alt: string;
}) {
  // 업로드본은 이미 완성된 절대 URL 이다. `docs/` 를 덧붙이면 있지도 않은 경로를
  // 안내하게 된다(`docs/https://cdn...`).
  const label = /^https?:\/\//i.test(assetKey) ? assetKey : `docs/${assetKey}`;

  return (
    <div className="grid min-h-40 place-items-center gap-1.5 border-2 border-dashed border-neutral-200 bg-neutral-50 px-4 py-8 text-center dark:border-white/12 dark:bg-white/5">
      <p className="text-[13px] text-neutral-500 dark:text-neutral-400">{alt}</p>
      <p className="max-w-full truncate font-mono text-[11px] text-neutral-400">
        준비 중 · {label}
      </p>
    </div>
  );
}
